import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('ancillary_service_area', '/ancillary_service_areas')
const reducer = generator.generate()

export default reducer
